// extracted by mini-css-extract-plugin
export var actions = "_ef-d";
export var benefitCard = "_ef-a";
export var benefitIcon = "_ef-b";
export var benefitLabel = "_ef-c";
export var benefits = "_ef-9";
export var bodyText = "_ef-8";
export var closeButton = "_ef-2";
export var content = "_ef-3";
export var eyebrow = "_ef-4";
export var heading = "_ef-5";
export var image = "_ef-f";
export var imagePanel = "_ef-e";
export var modal = "_ef-0";
export var shell = "_ef-1";
export var title = "_ef-6";
export var titleOffer = "_ef-7";